module.exports = __webpack_public_path__ + "img/typeText1.650dabf7.png";